webpackJsonp([35783957827783],{

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  min-height: 100%;\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n'], ['\n  width: 100%;\n  min-height: 100%;\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  ', '\n  color: white;\n  margin: 0;\n  font-size: 6vw;\n  text-transform: uppercase;\n  position: absolute;\n  display: flex;\n  z-index: 200;\n  opacity: 0;\n  ', '\n\n'], ['\n  ', '\n  color: white;\n  margin: 0;\n  font-size: 6vw;\n  text-transform: uppercase;\n  position: absolute;\n  display: flex;\n  z-index: 200;\n  opacity: 0;\n  ', '\n\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  height: calc(100% - 10rem);\n  width: calc(100% - 4rem);\n  position: absolute;\n  overflow: hidden;\n  z-index: -100;\n  border: 2px solid ', ';\n\n  opacity: 0;\n  animation: ', ' 1000ms forwards ', ';\n\n  @media screen and (min-width: ', '){\n    height: calc(100% - 20rem);\n    width: calc(100% - 8rem);\n  }\n'], ['\n  height: calc(100% - 10rem);\n  width: calc(100% - 4rem);\n  position: absolute;\n  overflow: hidden;\n  z-index: -100;\n  border: 2px solid ', ';\n\n  opacity: 0;\n  animation: ', ' 1000ms forwards ', ';\n\n  @media screen and (min-width: ', '){\n    height: calc(100% - 20rem);\n    width: calc(100% - 8rem);\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n'], ['\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 300;\n  opacity: 0;\n  animation: ', ' 1000ms 100ms forwards ', ';\n'], ['\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 300;\n  opacity: 0;\n  animation: ', ' 1000ms 100ms forwards ', ';\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  min-height: 100%;\n  min-width: 100%;\n  height: auto;\n  width: auto;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 400;\n  transform: translate(-50%,-50%);\n  animation: ', ' 1000ms 1000ms ease-in-out reverse forwards;\n'], ['\n  min-height: 100%;\n  min-width: 100%;\n  height: auto;\n  width: auto;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 400;\n  transform: translate(-50%,-50%);\n  animation: ', ' 1000ms 1000ms ease-in-out reverse forwards;\n']);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(31);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(43);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(13);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _theme = __webpack_require__(28);
	
	var theme = _interopRequireWildcard(_theme);
	
	var _zooperGrid = __webpack_require__(33);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function (_React$Component) {
	  _inherits(IndexPage, _React$Component);
	
	  function IndexPage() {
	    _classCallCheck(this, IndexPage);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this));
	  }
	
	  IndexPage.prototype.render = function render() {
	    var featuredImage = this.props.data.markdownRemark.frontmatter.featuredImage.childImageSharp.responsiveSizes;
	    return _react2.default.createElement(
	      SiteWrapper,
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Animator and Designer'
	        )
	      ),
	      _react2.default.createElement(
	        VideoWrap,
	        null,
	        _react2.default.createElement(
	          VideoWrapInner,
	          null,
	          _react2.default.createElement(
	            FullVideo,
	            { autoPlay: 'autoplay', loop: 'true', muted: 'true', playsInline: 'true', width: '1280', height: '720' },
	            _react2.default.createElement('source', { type: 'video/mp4', src: 'https://player.vimeo.com/external/125646400.hd.mp4?s=39beb785feceb7e668d30253e697589c466d6d76&profile_id=119' })
	          )
	        )
	      )
	    );
	  };
	
	  return IndexPage;
	}(_react2.default.Component);
	
	var SiteWrapper = _styledComponents2.default.div(_templateObject);
	
	var Title = _styledComponents2.default.h1(_templateObject2, theme.title, '' /* opacity: 0;
	                                                                            transform: translateY(6rem);
	                                                                            animation: ${theme.fadeIn} 3000ms 300ms forwards ${theme.easing.OutQuint},
	                                                                            ${theme.moveUp} 2000ms 350ms forwards ${theme.easing.OutQuint}; */);
	
	var VideoWrap = _styledComponents2.default.div(_templateObject3, theme.primaryColour, theme.fadeIn, theme.easing.OutQuint, theme.mdMin);
	var VideoWrapInner = _styledComponents2.default.div(_templateObject4);
	var FullVideo = _styledComponents2.default.video(_templateObject5, theme.fadeIn, theme.easing.OutQuint);
	var FeaturedImage = _styledComponents2.default.img(_templateObject6, theme.fadeIn);
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = IndexPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-d031a6a492d3cd6c755b.js